const INTERACTIVE_SELECTOR = [
  'input',
  'textarea',
  'select',
  'button',
  'a[href]',
  '[contenteditable="true"]',
  '[role="textbox"]',
  '[role="combobox"]',
  '[role="listbox"]',
  '[role="option"]',
  '[role="menu"]',
  '[role="menuitem"]'
].join(',')

const isPlayerShortcutSuppressedTarget = target => {
  if (!target || typeof target !== 'object') return false
  if (target.isContentEditable) return true

  if (typeof target.closest === 'function') {
    return Boolean(target.closest(INTERACTIVE_SELECTOR))
  }

  const tagName = String(target.tagName || '').toLowerCase()
  return ['input', 'textarea', 'select', 'button', 'a'].includes(tagName)
}

export {
  INTERACTIVE_SELECTOR,
  isPlayerShortcutSuppressedTarget
}
